import { DO_IT_LATER, UserActions, UserReducerState } from 'services/AuthService/User/types';

const INITIAL_STATE = {
  doItLater: false,
} satisfies UserReducerState;

const userDetailsReducer = (previousState: UserReducerState | undefined, action: UserActions): UserReducerState => {
  const state: UserReducerState = previousState ?? INITIAL_STATE;

  switch (action.type) {
    case DO_IT_LATER:
      return {
        ...state,
        doItLater: true,
      };
    default:
      return state;
  }
};

export default userDetailsReducer;
